import { Box } from '@mui/material';

import { DimensionSettings } from './DimensionSettings';

import type { TabPanelProps } from './vectorModal';

interface SettingsTabPanelProps extends TabPanelProps {}

function SettingsTabPanel({ selectedTab, modalId }: SettingsTabPanelProps) {
  return (
    <Box
      role="tabpanel"
      hidden={selectedTab !== 'settings'}
      id={`${modalId}-vertical-tabpanel-edit-stored-files`}
      aria-labelledby="vertical-tab-edit-stored-files"
      sx={{
        width: '100%',
        '&>*+*': {
          marginBlockStart: '2rem !important',
        },
        '&[hidden]': {
          display: 'none',
        },
      }}
    >
      <DimensionSettings />
    </Box>
  );
}

export { SettingsTabPanel };
